import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import PaperCustomized from "../../../common/components/PaperCustomized";
import TableCustomized from "../../../common/components/TableCustomized";
import { formattedDateFromDB } from "../../../common/utils/FunctionsUtils";
import { downloadTiFactureDocument } from "../state/TiActions";

function ListFactures(props) {
  const dispatch = useDispatch();

  const columns = [
    {
      field: "dateEmission",
      headerName: "Date d'emission",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "devise",
      headerName: "Devise",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "extension",
      headerName: "Extension",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "montant",
      headerName: "Montant",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "nom",
      headerName: "Nom du fichier",
      flex: 2,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "reference",
      headerName: "Réference facture",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "banque",
      headerName: "Banque",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "etat",
      headerName: "État",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "show",
      headerName: "",
      minWidth: 45,
      maxWidth: 45,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <IconButton
          onClick={() => handleShowClick(params)}
          aria-label="View"
          size="small"
          edge="start"
          sx={{ color: "primary.main" }}
        >
          <VisibilityIcon />
        </IconButton>
      ),
    },
    {
      field: "download",
      headerName: "",
      minWidth: 45,
      maxWidth: 45,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <IconButton
          onClick={() => handleDownloadClick(params)}
          aria-label="Download"
          size="small"
          edge="start"
          sx={{ color: "primary.main" }}
        >
          <FileDownloadIcon />
        </IconButton>
      ),
    },
  ];

  const rows = [];
  props?.detail?.arrTiFacturas?.map((row, index) => {
    rows.push({
      id: row.id,
      devise: row.devise?.description,
      extension: row.extension,
      montant: row.montant,
      nom: row.nomFicher,
      reference: row.referenceFact,
      banque: row.banqueDescription,
      etat: props?.etat,
      dateEmission: formattedDateFromDB(row.dateEmission),
      guId: row.guId,
      parentId: row.parentId,
    });
  });

  const handleDownloadClick = (params) => {
    let guId = params.row?.guId;
    let nomFichier = params.row?.nom;
    let parentId = params.row?.parentId;
    console.log("handleDownloadClick ~ parentId:", parentId);
    console.log("handleDownloadClick ~ nomFichier:", nomFichier);
    console.log("handleDownloadClick ~ guId:", guId);
    dispatch(
      downloadTiFactureDocument(
        guId ? guId : encodeURIComponent(nomFichier),
        parentId,
        "DOWNLOAD"
      )
    );
  };

  const handleShowClick = (params) => {
    let guId = params.row?.guId;
    let nomFichier = params.row?.nom;
    let parentId = params.row?.parentId;
    dispatch(
      downloadTiFactureDocument(
        guId ? guId : encodeURIComponent(nomFichier),
        parentId,
        "SHOW"
      )
    );
  };

  return (
    <PaperCustomized title={"Factures"} forActions={false}>
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={rows.length}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="client"
        isSlots={false}
        isFooter={true}
        noDataHeight="120px"
        cursor="auto"
      />
    </PaperCustomized>
  );
}

export default ListFactures;
